<template>
  <div>
    <Login ref="login" @login="login" />
  </div>
</template>

<script>
import Login from '@/components/payments/Login';

export default {
  data() {
    return {
    };
  },
  components: {
    Login,
  },
  computed: {
  },
  methods: {
    login() {
      this.$router.push({ name: 'my pages' });
    },
  },
  mounted() {
    this.$refs.login.logout();
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.my-name
  font-size: 13px;
  font-weight: 300;
  text-align: center;
  color: #262626;
  padding 15px
  border-bottom solid 1px #ececec;

.my-page-component
  background-color #F9F9F9
  min-height 80vh
  padding-top 50px

.inner
  background-color white
  max-width 936px
  margin 0 auto
  .tab-buttons
    display flex
    border-radius: 4px;
    background-color: #ecf5f8;

    .tab-button
      flex-grow: 1;
      width: 20%;
      text-align center
      padding-top 20px
      height 92px
      cursor pointer
      &.active
        background-color #005580

      .icon
        margin-bottom 5px

      span
        display block
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        uppercase()
        color: #262626;
      &.active
        span
          color white
</style>



// WEBPACK FOOTER //
// MyPageLogout.vue?6045636a